import React, {PropsWithChildren, useContext, useEffect, useState} from 'react'
import {SettingsDto, UpdateSettingsBody} from '../../services/Settings/type'
import {SettingsService} from '../../services/Settings'

interface SettingsContext {
  settings?: SettingsDto
  updateSettings: (body: UpdateSettingsBody) => Promise<void>
  loading?: boolean
}

const Context = React.createContext<SettingsContext>(null as any)

interface SettingsContextProviderProps {}

export const SettingsContextProvider: React.FC<PropsWithChildren<SettingsContextProviderProps>> = ({children}) => {
  const [settings, setSettings] = useState<SettingsDto>()
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    fetchSettings()
  }, [])

  const fetchSettings = async () => {
    try {
      const settings = await SettingsService.getSettings()
      setSettings(settings)
    } catch (error) {
      console.error('Error fetching Xpert Knowledge Tutorials:', error)
    } finally {
      setLoading(false)
    }
  }

  const updateSettings = async (body: UpdateSettingsBody) => {
    try {
      const updatedSettings = await SettingsService.updateSettings(body)
      setSettings(updatedSettings)
    } catch (error) {
      console.error('Error updating Settings:', error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Context.Provider
      value={{
        settings,
        updateSettings,
        loading,
      }}
    >
      {children}
    </Context.Provider>
  )
}

export const useSettingsContext = () => useContext(Context)
